import { WeezSocket } from "@weezevent/piglet";
import { inIframe } from './scroll';

WeezSocket.listen();

export const getParentUrl = async () => {
    let url = null;
    // When in an iframe, we have to get the parent url thanks to piglet (the script embedded at the top level).
    if (inIframe()) {
        try {
            let pigletResponse = await WeezSocket.send(
                {
                    type: "parent-url",
                    origin: "neo",
                },
                { needs_answer: true },
            )
            url = new URL(pigletResponse.payload.parentUrl).toString();
        } catch (e) {
            console.error("Cannot get the parent URL, check if the iframe is properly integrated.");
        }
    }
    return url;
};